export default "__VITE_ASSET__CPaTBUaz__"